import React, { useState } from 'react'
import DeckGL from '@deck.gl/react'
import { MapController } from 'deck.gl'
import { StaticMap } from 'react-map-gl'
import { EditableGeoJsonLayer, DrawPointMode, ViewMode } from 'nebula.gl'
import '../static/css/style.css'

import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { Divider } from '@material-ui/core'

import { Redirect } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: 200
    }
  }
}))

function PinDrop (props) {
  const classes = useStyles()

  const initialViewState = {
    longitude: 121.01821,
    latitude: 14.55816,
    zoom: 11
  }

  const point = {
    type: 'FeatureCollection',
    features: [
      { 'type': 'Feature',
        'geometry': { 'type': 'Point', 'coordinates': [0, 0] },
        'properties': { 'contour': 30 }
      }
    ]
  }

  const [viewport, setViewport] = useState()
  const [selected, setSelected] = useState(point)
  const [slug, setSlug] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [mode, setMode] = useState({ 'mode': ViewMode })

  const loadMeta = (to, frm, message) => {
    let url = new URL('https://us-central1-tm-christmais.cloudfunctions.net/create-metadata')
    let params = {
      'to': to,
      'from': frm,
      'message': message }

    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    fetch(url.href).then(res => res.json()).then((result) => {
      setSlug(result['slug'])
      setLoaded(true)
    })
  }

  return (
    loaded
      ? <Redirect to={'/' + selected.features[0].geometry.coordinates.join('/') + '/' + slug} />
      : <div className='pin-map' >
        <div>
          <DeckGL
            initialViewState={initialViewState}
            controller={{ type: MapController, dragRotate: false }}
            // viewState={viewState}
            onViewportChange={v => setViewport(v)}
            getCursor={() => mode['mode'] == ViewMode ? 'grab' : 'crosshair'}
          >

            <StaticMap
              mapboxApiAccessToken={'pk.eyJ1IjoidGhpbmtkYXRhc2NpIiwiYSI6ImNqbGhrMXNkMDFqNmYza3BhNHZtbDdzbnEifQ.XZF72CZ-zTaY6mLLwEcE2A'}
              mapStyle='mapbox://styles/thinkdatasci/ck4dkqowz0a671cqmvdgb3af4'
              {...props}
            />

            <EditableGeoJsonLayer
              id='geojson-layer'
              data={selected}
              mode={mode.mode}
              onEdit={({ updatedData }) => {
                setSelected({ 'type': 'FeatureCollection', 'features': updatedData.features.slice(-1) })
                setMode({ mode: ViewMode })
              }}
              pointRadiusMinPixels={4}
              stroked={false}
              getFillColor={[235, 88, 56]}
            />

          </DeckGL>

        </div>
        <div className='card-details'>
          <div className='step title'>
            <h2> Make your own </h2>
            <h2><i style={{ color: '#eb5838' }} >Geospatial Christmas Card!</i></h2>
          </div>
          <Divider />
          <div className='step step-one'>
            <p className='section one'><strong>Step 1:</strong> Select a location </p>
            <div className='button-group'>
              <button
                className='activate-draw'
                onClick={function () {
                  setMode({ 'mode': DrawPointMode })
                }}
                style={{ backgroundColor: mode['mode'] == ViewMode ? '#ffffff' : '#f0f0f0' }}
              >
                <svg id='drop-pin' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 85'>
                  <path className='cls-2' style={{ fill: mode['mode'] == ViewMode ? '#1e1e1e' : '#b9b7b7' }} d='M56.79,35.66A27.49,27.49,0,0,0,55.63,19.3C51.9,10.19,45.25,4.58,35.88,2.64a26.14,26.14,0,0,0-24.4,7.11A26.2,26.2,0,0,0,3.27,28.32,41.54,41.54,0,0,0,6.55,45.15,79.85,79.85,0,0,0,16.2,62.42c.71,1,1.47,2,2.31,3.12C8.9,67,4,69.83,4,74.12,4,81,18,83.5,30,83.5s26-2.46,26-9.38c0-5.11-7.25-7.46-14.26-8.54A113.53,113.53,0,0,0,50.6,51.73,57.47,57.47,0,0,0,56.79,35.66ZM23.3,71.36c1.22,1.39,2.29,2.57,3.34,3.65a5.12,5.12,0,0,0,3.67,1.57h.12a5.21,5.21,0,0,0,3.74-1.75l.3-.34c.82-.94,1.67-1.94,2.62-3.09,6.65.62,10.27,1.93,11.81,2.73-2.21,1.11-8.4,3-18.92,3s-16.72-1.92-18.92-3C12.63,73.31,16.37,72,23.3,71.36Zm7-1.72a101.41,101.41,0,0,1-8.91-10.89,72.86,72.86,0,0,1-8.91-15.91A35.41,35.41,0,0,1,9.61,28.53a20,20,0,0,1,6.27-14.21,19.78,19.78,0,0,1,14-6,23.06,23.06,0,0,1,4.67.5c7.19,1.49,12.29,5.82,15.17,12.86a21.3,21.3,0,0,1,.82,12.69A51.64,51.64,0,0,1,45,48.71,117.08,117.08,0,0,1,30.28,69.64Z' transform='translate(-3.25 -2.01)' />
                  <path className='cls-1' style={{ fill: mode['mode'] == ViewMode ? '#c05638' : '#b9b7b7' }} d='M41.35,25.12,36,24.34a1.92,1.92,0,0,1-1.44-1l-2.43-4.79a1.94,1.94,0,0,0-3.45,0L26.27,23.3a1.92,1.92,0,0,1-1.44,1l-5.33.78a1.94,1.94,0,0,0-1.2,3.16l3.61,4.31a1.93,1.93,0,0,1,.43,1.56l-.84,4.93a1.93,1.93,0,0,0,2.77,2.05l5.29-2.64a2,2,0,0,1,1.73,0l5.29,2.64a1.93,1.93,0,0,0,2.77-2.05l-.84-4.93a1.92,1.92,0,0,1,.42-1.56l3.62-4.31A1.94,1.94,0,0,0,41.35,25.12Z' transform='translate(-3.25 -2.01)' />
                </svg>
              </button>
              <p> Click then drop the pin! </p>
            </div>
          </div>
          <Divider />
          <div className='step step-two'>
            <p className='section two'><strong>Step 2:</strong> Write your message </p>
            <TextField
              id='standard-multiline-flexible'
              className={classes.root}
              label='To'
              multiline
              rowsMax='1'
              value={props.to}
              onChange={props.changeTo}
            />
            <TextField
              id='standard-multiline-flexible'
              className={classes.root}
              label='From'
              multiline
              rowsMax='1'
              value={props.frm}
              onChange={props.changeFrm}
            />
            <TextField
              id='standard-multiline-flexible'
              className={classes.root}
              label='Message'
              multiline
              rows='8'
              value={props.message}
              onChange={props.changeMessage}
              variant='outlined'
            />
          </div>
          <div className='step step-three'>
            {selected === point || !props.to || !props.frm || !props.message
              ? <button disabled> Generate Card </button>
              : <button
                onClick={() => loadMeta(props.to, props.frm, props.message)}
              >
            Generate Card
              </button>
            }
          </div>
        </div>
      </div>
  )
}

export default PinDrop
